module.exports = __webpack_public_path__ + "static/media/input_spinner.4f8e7f3f.svg";